import { cn } from "@/lib/utils";

export interface OversightColumn {
  title: string;
  items: string[];
}

export interface OversightTableProps {
  /** Array of oversight columns */
  columns: OversightColumn[];
  /** Additional className */
  className?: string;
}

/**
 * molecule-table-oversight
 * 
 * A three-column oversight table pattern for governance/structure display.
 * 
 * Tokens applied:
 * - Container: grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12
 * - Header: text-lg font-bold text-carbon (pitch black)
 * - Items: text-sm text-carbon, divide-y divide-border/50
 * - Item padding: py-2.5 first:pt-0
 */
export function OversightTable({ columns, className = "" }: OversightTableProps) {
  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12", className)}>
      {columns.map((column) => (
        <div key={column.title}>
          {/* atom-text-oversight-header: text-lg font-bold text-carbon */}
          <h3 className="text-lg font-bold text-carbon mb-4">
            {column.title}
          </h3>
          {/* molecule-list-divider: divide-y with py-2.5 */}
          <ul className="divide-y divide-border/50">
            {column.items.map((item) => (
              <li 
                key={item} 
                className="text-sm text-carbon py-2.5 first:pt-0"
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default OversightTable;
